<div style="padding:30px;margin-left:10px ;"> 

    <button (click)="add()" class="btn btn-primary" style="margin-bottom: 0.5%;">點我新增模板</button>
    <select class="form-control" style="width: 160px;margin-left: 3%;display: inline-block;margin-bottom: 1%;" [(ngModel)]="search_gender" (change)="init_list()">
        <option *ngFor="let item of gender_list" [ngValue]="item.id">{{item.name}}</option>
    </select>
    <select class="form-control" style="width: 160px;margin-left: 3%;display: inline-block;margin-bottom: 1%;" [(ngModel)]="search_chat_type" (change)="init_list()">
        <option *ngFor="let item of chat_type_list" [ngValue]="item.id">{{item.name}}</option>
    </select>
    <app-table-v2  *ngIf="data.length>0" [type]="1" [tcontent]="tcontent" [data]="data">
        <ng-template let-post #operation_dk>
            <div *ngIf="post.key == 'gender'">
               <div *ngIf="post.val.gender == 1">男</div>
               <div *ngIf="post.val.gender == 2">女</div>
               <div *ngIf="post.val.gender == 3">不限(官方帳號)</div>
            </div>
            <div *ngIf="post.key == 'is_enable'">
                <app-checkswitch [item]="post.val" [enabletype]="1" [type]='2' (statusChange)="handleStatusChange($event,post.val)"></app-checkswitch>
            </div>

            <div *ngIf="post.key == 'gg'">
                <button (click)="edit_data=post.val;now='0'"  class="btn btn-info" data-toggle="modal" data-target=".bd-example-modal-lg">點我編輯</button>
            </div>
        </ng-template> 
    </app-table-v2>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    <div *ngIf="data.length==0">無資料</div>
</div>

<div 
*ngIf="edit_data"
class="modal fade bd-example-modal-lg" tabindex="-1"
 role="dialog"  data-keyboard="false" data-backdrop="static" 
 aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"

 >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
          <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="now=item.id">
            <a onclick="return false;" [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</a>
          </li>
        </ul>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body"> 
        <div class="wrape_item" *ngIf="now=='0'" style="margin:20px 0px 0px 0px">
            <span class="show_title" >性別：</span>
            <select class="form-control"
                style="width: 160px;display: inline-block;"
                [(ngModel)]="edit_data.gender"
            >
                <option *ngFor="let item of gender_option" [ngValue]="item.id">{{item.name}}</option>
            </select>
         </div>
         <div class="wrape_item" *ngIf="now=='0'" style="margin:20px 0px 0px 0px">
            <span class="show_title" >類型：</span>
            <select class="form-control"
                style="width: 160px;display: inline-block;"
                [(ngModel)]="edit_data.type"
            >
                <option *ngFor="let item of type_option" [ngValue]="item.id">{{item.name}}</option>
            </select>
         </div>
        <div class="wrape_item" style="display: flex;" *ngIf="now=='0'">
           <span class="show_title" style="margin-top: 3%;">內容：</span>
           <input type="text" 
            [(ngModel)]="edit_data.content" 
            class="form-control show_input" 
            style="width: 91%;margin-top: 2%;" 
          >
        </div>

         <div class="wrape_item" *ngIf="now=='0'" style="margin:20px 0px 0px 0px">
            <span class="show_title" >狀態：</span>
            <input type="radio"  [(ngModel)]="edit_data.is_enable" value="1">上架
            <input type="radio"  [(ngModel)]="edit_data.is_enable" value="0">下架
         </div>   
      </div>

      <div class="modal-footer">
          <button type="button"  (click)="save(0)"  class="btn btn-primary" data-dismiss="modal">確認</button>
          <button type="button"  (click)="init_list()" class="btn btn-danger" data-dismiss="modal">取消</button>
      </div>
      </div>
  </div>
</div>
<app-spinner [loading]="loading"></app-spinner>